/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { GoWizardCloseResponseWrapperGowizardClose } from './GoWizardCloseResponseWrapperGowizardClose'
import {
  GoWizardCloseResponseWrapperGowizardCloseFromJSON,
  GoWizardCloseResponseWrapperGowizardCloseFromJSONTyped,
  GoWizardCloseResponseWrapperGowizardCloseToJSON,
} from './GoWizardCloseResponseWrapperGowizardClose'

/**
 * Legacy response wrapper structure to allow matching the original
 * configurator web API.
 *
 * TODO: This should be removed after the .Net Core and ScdsClient
 * migration has been completed.
 * @export
 * @interface GoWizardStartResponseWrapper
 */
export interface GoWizardStartResponseWrapper {
  /**
   *
   * @type {GoWizardCloseResponseWrapperGowizardClose}
   * @memberof GoWizardStartResponseWrapper
   */
  gowizardStart: GoWizardCloseResponseWrapperGowizardClose
}

/**
 * Check if a given object implements the GoWizardStartResponseWrapper interface.
 */
export function instanceOfGoWizardStartResponseWrapper(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'gowizardStart' in value

  return isInstance
}

export function GoWizardStartResponseWrapperFromJSON(
  json: any,
): GoWizardStartResponseWrapper {
  return GoWizardStartResponseWrapperFromJSONTyped(json, false)
}

export function GoWizardStartResponseWrapperFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GoWizardStartResponseWrapper {
  if (json === undefined || json === null) {
    return json
  }
  return {
    gowizardStart: GoWizardCloseResponseWrapperGowizardCloseFromJSON(
      json['gowizard_start'],
    ),
  }
}

export function GoWizardStartResponseWrapperToJSON(
  value?: GoWizardStartResponseWrapper | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    gowizard_start: GoWizardCloseResponseWrapperGowizardCloseToJSON(
      value.gowizardStart,
    ),
  }
}
